<div class="dialog" style="width: min-content;">
  <h2 style="margin-bottom: 12px;">
    Configure Custom {{ label }} Tiering Mode
  </h2>

  <p style="margin-bottom: 20px;">
    Set the threshold values for each {{ label }} tier. If an item's value is greater than or equal to the threshold value, it will be displayed in that tier. You can both use decimals or fractions (e.g. 1/10 or even 3/4).
  </p>

  <div class="filter-group">
    <div class="filter-group-body">
      @for (tierValue of tierValues; track tierValue.tier; let i = $index) {
        <div class="filter filter-property">
          <span class="filter-body">
            @switch (labelMode) {
              @case ('currency') {
                <div class="styled-tier-label">
                  <app-tier-style
                    [displayable]="getTierCosmetic(tierValue.tier)!"
                    [allowedDisplayTypes]="[DisplayType.Custom]"
                    [allowDisactivate]="false"
                    [label]="getTierName(tierValue.tier)"
                    [isHeader]="true"
                    [isTitle]="true"
                    [isCurrency]="true"
                    [exampleName]="'Example Orb'"
                    [styleDialogTitle]="getTierName(tierValue.tier)">
                  </app-tier-style>
                </div>
              }
              @case ('unique') {
                <div class="styled-tier-label">
                  <app-tier-style
                    [displayable]="getTierCosmetic(tierValue.tier)!"
                    [allowedDisplayTypes]="[DisplayType.Custom]"
                    [allowDisactivate]="false"
                    [label]="tierValue.tier"
                    [isHeader]="true"
                    [isTitle]="true"
                    [rarity]="Rarity.Unique"
                    [exampleName]="'Example Unique'"
                    [styleDialogTitle]="tierValue.tier">
                  </app-tier-style>
                </div>
              }
              @case ('plain') {
                <div class="styled-tier-label" style="display: flex; align-items: center; width: 100px !important; font-weight: bold;">
                  {{ tierValue.tier }}
                </div>
              }
            }
            <span class="sep"></span>
            <div class="filter-title filter-label" style="width: 75px !important">
              Value ≥
            </div>
            <span class="sep"></span>
            <input
              type="text"
              pattern="[0-9.,/]*"
              inputmode="decimal"
              class="form-control minmax"
              [(ngModel)]="valueInputs[tierValue.tier]"
              (ngModelChange)="onValueInputChange(tierValue.tier, $event)"
              [disabled]="i === tierValues.length - 1"
              style="min-width: 65px; width: 65px;">
            <span class="sep"></span>
            <app-select [class.include-comparator]="false" [hideHoverInfo]="true" [(ngModel)]="tierValue.baseCurrency" style="width: 150px; text-align: left;" [disabled]="i === tierValues.length - 1">
              @for (baseCurrencyType of baseCurrencyTypes; track baseCurrencyType.name) {
                <app-option [value]="baseCurrencyType.name" [text]="baseCurrencyType.name" [imgUrl]="imgPrefix + baseCurrencyType.image"></app-option>
              }
            </app-select>
          </span>
        </div>
      }
    </div>
  </div>

  <div class="dialog-controls">
    <button type="button" class="btn dialog-btn dialog-main-btn" [disabled]="!isValid()" (click)="save()">
      Save
    </button>
    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="cancel()">
      Cancel
    </button>
  </div>
</div>
